(function($) {
    window.toast = function(config) {
		var backgroundColor = ''; /* background color */
		var color = ''; /* font color */
		var duration = 5000; /* live span in milliseconds */
		var text = 'No toast text set!';
		var cssClass = '';

		var toast = null;
		var closeTimeout = null;

		if (typeof config.text !== 'undefined' && config.text != '') {
			text = config.text;
		}
		if (typeof config.backgroundColor !== 'undefined' && config.backgroundColor != '') {
			backgroundColor = config.backgroundColor;
		}
		if (typeof config.color !== 'undefined' && config.color != '') {
			color = config.color;
		}
		if (typeof config.duration !== 'undefined' && config.duration != '') {
			duration = config.duration;
		}
		if (typeof config.cssClass !== 'undefined' && config.cssClass != '') {
			cssClass = config.cssClass;
		}

		this.open = function() {
			if ($('body').children('.toast-container').length == 0) {
				$('body').append($('<div />', {
						'class': 'toast-container'
				}));
			}

			var toastContainer = $('body').children('.toast-container').first();
			if (toast === null) {
				toast = $('<div />', {
						'class': 'toast',
						'css': {
							'background-color': backgroundColor,
							'color': color
						},
						'html': text
				});
				toastContainer.append(toast);
				if (backgroundColor != '') {
					$(toast).css('background-color', backgroundColor);
				}
				if (color != '') {
					$(toast).css('color', color);
				}
				if (cssClass != '') {
					$(toast).addClass(cssClass);
				}

				$(toast).animate({
					'opacity': '1',
					'margin-top': '0'
				}, 300, function() {
					closeTimeout = window.setTimeout(function() {
							close();
					}, duration);
				});
			}
			else {
				clearTimeout(closeTimeout);
				closeTimeout = window.setTimeout(function() {
						close();
				}, duration);
			}
		};

		var close = function() {
				$(toast).animate({
					'opacity': 0,
					'margin-top': '-60px'
				}, 300, function() {
					$(this).remove();
					toast = null;
					if ($('body').children('.toast-container').first().find('.toast').length == 0) {
						$('body').children('.toast-container').remove();
					}
				});
		};
	
	};

	$.fn.toast = function() {
		return this.each(function() {
				$(this).on('click', function(event) {
						event.preventDefault();

						var opener = $(this);
						var config = {};

						if ($(opener).attr('data-text') != '') {
							config.text = $(opener).attr('data-text');
						}
						if ($(opener).attr('data-background') && $(opener).attr('data-background') != '') {
							config.backgroundColor = $(opener).attr('data-background');
						}
						if ($(opener).attr('data-color') && $(opener).attr('data-color') != '') {
							config.color = $(opener).attr('data-color');
						}
						if ($(opener).attr('data-duration') && $(opener).attr('data-duration') != '') {
							config.duration = $(opener).attr('data-duration');
						}
						if ($(opener).attr('data-css-class') && $(opener).attr('data-css-class') != '') {
							config.cssClass = $(opener).attr('data-css-class');
						}
						var TostInstance = new window.toast(config);

						TostInstance.open();
				});
		});
	};
})(jQuery);